import {useEffect} from 'react'
function usePageTitle(value) {
  useEffect(() => {
    document.title = `${value} - ${process.env.REACT_APP_APP_NAME} | SaaS Onboarding Tool for Streamlined Digital Employee Onboarding`
  }, [value])
}
export default usePageTitle
